import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
      Abi’ naskiĝis en arbar’ <br/>
      Kaj kreskis kun fier’, <br/>
      Ĉar verda estis ĝia vest’ <br/>
      Dum vintro kaj somer’.
      </p>

      <p class="poem-block mb-3">
      Karese kantis neĝa vent’: <br/>
      «Vi dormu en kviet’!» <br/>
      Pro mola neĝ’ de avo-frost’ <br/>
      Varmiĝis abiet’.
      </p>

      <p class="poem-block mb-3">
      Timema griza leporet’ <br/>
      Saltadis sub abi’. <br/>
      Kaj foje lup’, severa lup’ <br/>
      Kuradis preter ĝi.
      </p>

      <p class="poem-block mb-3">
      Jen knaras sub la sledo neĝ’, <br/>
      Rapidas la ĉeval’ <br/>
      Kaj kuras vigle tra l’ arbar’ <br/>
      En neĝkovrita val’.
      </p>

      <p class="poem-block mb-3">
      Alvenis rapidkura sled’, <br/>
      Gvidata de «muĵik’». <br/>
      Forhakis abieton li <br/>
      Precize sub radik’.
      </p>

      <p class="poem-block mb-3">
        Kaj poste venis kun ornam’ <br/>
        Abi’ en bela vest’, <br/>
        Kaj portis multan ĝojon ĝi <br/>
        Al nia gaja fest’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Abi’ naskiĝis en arbar’'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['VAG1UTfDSjY'],
    itemTranslator: `
      Teksto: Raisa Kudaŝeva, <br/>
      Muziko: L. Bekman <br/>
      ${translator.esp}
    `
  }
}

export default item;